<template>
  <div class="outBox">
    <div class="leftBox">
      <img
        src="../assets/login/newLogin.png"
        alt=""
        height="100%"
        width="100%"
      />
    </div>
    <div class="fixBox">
      <img
        src="../assets/login/login_logo_blue.png"
        width="160px"
        height="30px"
        alt=""
      />
    </div>
    <div class="rightBox">
      <div>
        <div class="asTitle">{{ $t("title.loginTitle") }}</div>
        <div class="loginType">{{ $t("loginPage.userLogin") }}</div>
        <div class="line" style="display: flex">
          <div style="height: 2px; background: #015ac5; width: 30%"></div>
          <div
            style="
              height: 2px;
              background: rgba(83, 132, 190, 0.21);
              width: 70%;
            "
          ></div>
        </div>
        <div class="loginBox" v-if="loginType == 'normal'">
          <div class="inputBox" id="inputBox">
            <div>
              <div class="label">{{ $t("loginPage.username") }}</div>
              <div>
                <el-input
                  v-model="loginForm.username"
                  :placeholder="$t('loginPage.pleaseInputUsername')"
                ></el-input>
              </div>
            </div>
            <div style="margin-top: 25px">
              <div class="label">{{ $t("loginPage.password") }}</div>
              <div>
                <el-input
                  :type="inputType"
                  v-model="loginForm.password"
                  :placeholder="$t('loginPage.pleaseInputPassword')"
                  @keyup.enter.native="login()"
                >
                  <i
                    style="cursor: pointer"
                    @click="inputTypeChange"
                    slot="suffix"
                    :class="
                      inputType == 'text'
                        ? 'el-input__icon el-icon-pwd-show customIcon'
                        : 'el-input__icon el-icon-pwd-hid customIcon'
                    "
                  ></i>
                </el-input>
              </div>
            </div>
          </div>
          <div class="loginButtonClass" style="margin: 10px 0px 20px 0px">
            <el-button style="width: 100%" type="primary" @click="login">{{
              $t("button.login")
            }}</el-button>
          </div>
        </div>

        <div
          class="loginBox"
          style="align-items: center"
          v-if="loginType == 'wx'"
        >
          <div id="wxQrcode" ref="wxQrcode"></div>
        </div>

        <!-- <el-divider v-if="wxSwitch" style="color:#e2e2e2">or</el-divider> -->
        <el-divider style="color: #e2e2e2" v-if="azureLoginSwitch || wxSwitch"
          >or</el-divider
        >
        <div>
          <div
            class="otherLoginButtonBox"
            v-if="loginType != 'microsoft' && azureLoginSwitch"
            @click="changeLogin('microsoft')"
          >
            <img
              src="../assets/login/ms-symbollockup_mssymbol_19.png"
              alt=""
              height="21px"
              width="21px"
            />
            <span>{{ $t("loginPage.microsoftLogin") }}</span>
          </div>
          <div
            class="otherLoginButtonBox"
            v-if="loginType != 'wx' && wxSwitch"
            @click="changeLogin('wx')"
          >
            <img
              src="../assets/login/wc.png"
              alt=""
              height="21px"
              width="21px"
            />
            <span> {{ $t("loginPage.useWxLogin") }}</span>
          </div>
          <div
            class="otherLoginButtonBox"
            v-if="loginType != 'normal'"
            @click="changeLogin('normal')"
          >
            <img
              src="../assets/login/user.png"
              alt=""
              height="21px"
              width="21px"
            />
            <span> {{ $t("button.normalLogin") }}</span>
          </div>
        </div>
      </div>

      <div style="text-align: center">
        <p
          style="
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 14px;
          "
        >
          {{ $t("hanshow.copyright") }}
          <i class="iconfont icon-banquan"></i>
          {{ $t("hanshow.year") }}
          {{ $t("hanshow.product") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
// import aes from "@/utils/aes.js";
import { guid, isEmpty } from "@/utils/utils.js";
import QRCode from "qrcodejs2";
import { dataToDay } from "@/utils/utils.js";
export default {
  created() {
    this.getLoginPageConfig();
  },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      // 密码输入框类型 ， 用于修改显示隐藏状态
      inputType: "password",

      // 登陆类型
      loginType: "normal",
      //登录成功定时器
      loginCallBackInterval: "",
      //二维码超时定时器
      qrcodeOverTimeInterval: "",

      //微信登录随机串
      wxLoginStr: "",
      //微信登录是否开启
      wxSwitch: false,
      //azure登录是否开启
      azureLoginSwitch: false,
    };
  },
  methods: {
    inputTypeChange() {
      this.inputType == "text"
        ? (this.inputType = "password")
        : (this.inputType = "text");
    },
    getLoginPageConfig() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getLoginPageConfig()
          .then((res) => {
            if (res.resultCode == 1001) {
              if (!isEmpty(res)) {
                this.wxSwitch =
                  res.data.find((item) => item.name == "wechatSwitch")?.value ??
                  false;
                this.azureLoginSwitch =
                  res.data.find((item) => item.name == "azureSSOSwitch")
                    ?.value ?? false;
              }
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    login() {
      let submitInfo = {
        username: this.loginForm.username,
        password: md5(
          this.loginForm.password + this.loginForm.username
        ).toUpperCase(),
      };
      return new Promise((resolve, reject) => {
        this.$httpList
          .login(submitInfo)
          .then((res) => {
            if (res.resultCode == 1001) {
              localStorage.setItem("as-username", res.data.username);
              //token 加密存储
              localStorage.setItem(
                "accessToken",
                // aes.encrypt(res.data.access_token)
                res.data.access_token
              );
              if (localStorage.getItem("accessToken")) {
                // //TODO  把加密后的accessToken 解密
                this.$actions.setGlobalState({
                  accessToken: res.data.access_token,
                });
                /**
                 * 0 未开启   无需处理 正常登陆进入
                 * 1 用户自开启   默认进入输入验证码页面
                 * 2 强制开启    进入验证码页面
                 * 3 强制开启未绑定  进入强制绑定页面
                 * 4 已绑定未开启     无需处理  正常登陆进入
                 */
                //Google登录注册
                if ([1, 2].includes(res.data.googleType)) {
                  this.$router.push({
                    name: "GoogleLogin",
                    params: {
                      username: submitInfo.username,
                      userFirstLogin: JSON.parse(res.data?.userFirstLogin),
                      passwordModifyExpires: JSON.parse(
                        res.data?.passwordModifyExpires
                      ),
                    },
                  });
                } else if (res.data.googleType == 3) {
                  this.$router.push({
                    name: "ForceBind",
                    params: {
                      username: submitInfo.username,
                    },
                  });
                } else if ([0, 4].includes(res.data.googleType)) {
                  this.$httpList.isHaveLicense().then((rs) => {
                    if (rs.resultCode == 1001) {
                      rs.data.expirationTime =
                        new Date(
                          dataToDay(rs.data.expirationTime) + " 00:00:00"
                        ).getTime() +
                        24 * 60 * 60 * 1000 -
                        1;
                      if (!rs.data.permanentAuthorization) {
                        if (new Date().getTime() < rs.data.expirationTime) {
                          this.$store.commit("config/changeTipsStatus", false);
                        }
                      } else {
                        this.$store.commit("config/changeTipsStatus", true);
                      }
                      if (
                        JSON.parse(res.data?.userFirstLogin) == true ||
                        JSON.parse(res.data?.passwordModifyExpires) == true
                      ) {
                        this.$router.push({
                          name: "forcePwdChange",
                          params: {
                            userFirstLogin: JSON.parse(
                              res.data?.userFirstLogin
                            ),
                            passwordModifyExpires: JSON.parse(
                              res.data?.passwordModifyExpires
                            ),
                          },
                        });
                      } else {
                        this.$router.push({
                          name: "Home",
                        });
                      }
                    }
                  });
                }
              } else {
                this.$notify({
                  type: "error",
                  message: this.$t("promptMessage.getTokenError"),
                });
              }
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    changeLogin(data) {
      if (this.loginType == "wx") {
        this.$refs.wxQrcode.innerHTML = "";
        window.clearInterval(this.loginCallBackInterval);
        this.loginType = data;
      } else {
        if (data == "wx") {
          this.wxLoginStr = guid();
          this.loginType = data;
          this.$nextTick(() => {
            this.getQrCode();
            //调用微信获取二维码 内容 然后绘制二维码
          });
        } else if (data == "microsoft") {
          let requestForm = document.createElement("form");
          requestForm.style = "display:none";
          requestForm.method = "get";
          requestForm.action = "/proxy/allstar/v2/azure/login";
          requestForm.target = "_self";
          document.body.appendChild(requestForm);
          requestForm.submit();
          document.body.removeChild(requestForm);
        }
      }
    },
    getQrCode() {
      return new Promise((resolve, reject) => {
        let submitInfo = {
          key: "wxlogin",
          loginStr: this.wxLoginStr,
        };
        this.$httpList
          .getWxQrCodeContent(submitInfo)
          .then((res) => {
            if (res.resultCode == 1001) {
              console.log(res);
              this.$refs.wxQrcode.innerHTML = ""; // 清除二维码方法
              new QRCode("wxQrcode", {
                text: res.data.qrCodeContent,
                width: 200,
                height: 200,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });
              // 清除div title
              document.getElementById("wxQrcode").title = "";
              this.loginCallBackInterval = window.setInterval(() => {
                this.wxLogin().then((rs) => {
                  if (rs.resultCode == 1001) {
                    window.clearInterval(this.loginCallBackInterval);
                    this.$notify.success({
                      message: this.$t("wechat.loginSuccess"),
                    });

                    localStorage.setItem("as-username", rs.data.username);
                    //token 加密存储
                    // localStorage.setItem(
                    //   "accessToken",
                    //   aes.encrypt(rs.data.access_token)
                    // );
                    if (localStorage.getItem("accessToken")) {
                      this.$actions.setGlobalState({
                        accessToken: rs.data.access_token,
                      });
                      if (
                        JSON.parse(rs.data?.userFirstLogin) ||
                        JSON.parse(rs.data?.passwordModifyExpires)
                      ) {
                        localStorage.setItem(
                          "as-pwdFlag",
                          JSON.stringify({
                            userFirstLogin: rs.data?.userFirstLogin,
                            passwordModifyExpires:
                              rs.data?.passwordModifyExpires,
                          })
                        );
                        this.$router.push({
                          name: "forcePwdChange",
                          params: {
                            userFirstLogin: JSON.parse(rs.data?.userFirstLogin),
                            passwordModifyExpires: JSON.parse(
                              rs.data?.passwordModifyExpires
                            ),
                          },
                        });
                      } else {
                        this.$router.push({
                          name: "Home",
                        });
                      }
                    } else {
                      console.log("获取token失败");
                    }
                  }
                });
              }, 1000);
            }

            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      }).then(() => {});
    },
    wxLogin() {
      return new Promise((resolve, reject) => {
        let submitInfo = {
          loginStr: this.wxLoginStr,
        };
        this.$httpList
          .wxLogin(submitInfo)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.otherLoginButtonBox {
  height: 40px;
  border-radius: 8px;
  border: #dcdfe6 solid 1px;
  display: flex;
  padding: 0px 12px;
  align-items: center;
  cursor: pointer;
  width: 100%;
  margin-top: 12px;
  img {
    margin-right: 12px;
  }
  span {
    color: #606266;
    font-size: 14px;
    white-space: nowrap;
  }
  &:hover {
    background-color: #e6e4e4;
    // color: #003594;
    & span {
      color: #003594;
    }
  }
}
.el-icon-pwd-hid {
  margin-right: 4px;
  background: url("../assets/login/ic_hid.png") center no-repeat;
}

.el-icon-pwd-show {
  margin-right: 4px;
  background: url("../assets/login/ic_show.png") center no-repeat;
}
.el-icon-wechat-login {
  background: url("../assets/login/wechatLogin.png") center no-repeat;
}
.fixBox {
  position: fixed;
  top: 7%;
  left: 4%;
}
.outBox {
  display: flex;
  height: 100%;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
  .leftBox {
    height: 100%;
    width: 60vw;
  }
  .rightBox {
    min-height: 300px;
    width: 40vw;
    padding: 9vh 8vw 0px 8vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .asTitle {
      font-size: 30px;
      font-weight: 600;
      color: #003594;
      line-height: 33px;
      text-align: center;
    }
    .loginType {
      font-size: 20px;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
      margin-top: 50px;
    }
    .loginBox {
      min-height: 336px;
      max-height: 336px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      margin-top: 50px;
      .inputBox {
        display: flex;
        flex-direction: column;
      }
    }
    .label {
      height: 14px;
      font-size: 12px;
      font-weight: 600;
      color: #585b61;
      line-height: 14px;
      margin-bottom: 5px;
    }
  }
}

.el-divider__text {
  color: #c5c5c5;
}
::v-deep .el-input__inner {
  border-radius: 8px !important;
}
::v-deep .el-button {
  border-radius: 8px !important;
}
</style>
